import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { DepartmentPicker } from './DepartmentPickerExtension';

export const DepartmentPickerFieldExtension = FormFieldBlueprint.make({
  name: 'department-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'DepartmentPicker',
        component: DepartmentPicker,
      }),
  },
});
